(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 45301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(52398);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DynamicApp; }
/* harmony export */ });
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);

var DynamicApp = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_0__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7611), __webpack_require__.e(2956), __webpack_require__.e(2016), __webpack_require__.e(8278), __webpack_require__.e(3662), __webpack_require__.e(78), __webpack_require__.e(3714), __webpack_require__.e(4219), __webpack_require__.e(2432), __webpack_require__.e(2440), __webpack_require__.e(7215), __webpack_require__.e(5453), __webpack_require__.e(461), __webpack_require__.e(7673), __webpack_require__.e(9060), __webpack_require__.e(8637), __webpack_require__.e(734), __webpack_require__.e(4653), __webpack_require__.e(3594), __webpack_require__.e(1217), __webpack_require__.e(7804), __webpack_require__.e(9483), __webpack_require__.e(6884), __webpack_require__.e(9241), __webpack_require__.e(7727), __webpack_require__.e(2287)]).then(__webpack_require__.bind(__webpack_require__, 22287)).then(function(lib) {
        return lib.App;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22287)
            ];
        }
    },
    ssr: false
});


/***/ }),

/***/ 73874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* reexport safe */ _loading_indicator__WEBPACK_IMPORTED_MODULE_0__.T; },
/* harmony export */   "D": function() { return /* reexport safe */ _themed_loading_indicator__WEBPACK_IMPORTED_MODULE_1__.D; }
/* harmony export */ });
/* harmony import */ var _loading_indicator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25792);
/* harmony import */ var _themed_loading_indicator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83315);




/***/ }),

/***/ 25792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ LoadingIndicator; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var LoadingIndicator = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute inset-0 flex items-center justify-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col items-center space-y-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    className: "animate-spin h-10 w-10 text-purple-400",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            className: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            strokeWidth: "4"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            className: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-gray-900 opacity-50 hidden",
                    children: "Loading..."
                })
            ]
        })
    });
};


/***/ }),

/***/ 83315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ThemedLoadingIndicator; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _loading_indicator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25792);



var ThemedLoadingIndicator = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute inset-0 themed-loading-indicator",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loading_indicator__WEBPACK_IMPORTED_MODULE_2__/* .LoadingIndicator */ .T, {})
    }));
};


/***/ }),

/***/ 97084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var site_v2_home__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23493);

/* harmony default export */ __webpack_exports__["default"] = (site_v2_home__WEBPACK_IMPORTED_MODULE_0__/* .Home */ .S);


/***/ }),

/***/ 52398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./pages/home.tsx
var home = __webpack_require__(97084);
// EXTERNAL MODULE: ./plugins/user-agent.ts
var user_agent = __webpack_require__(1230);
// EXTERNAL MODULE: ./app/dynamic-app.ts
var dynamic_app = __webpack_require__(86215);
// EXTERNAL MODULE: ./components/loading-indicator/index.ts
var loading_indicator = __webpack_require__(73874);
// EXTERNAL MODULE: ./site-v2/shared/meta.tsx
var meta = __webpack_require__(45386);
;// CONCATENATED MODULE: ./site-v2/loading.tsx




var Loading = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* Meta */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_indicator/* ThemedLoadingIndicator */.D, {})
        ]
    }));
};

;// CONCATENATED MODULE: ./pages/index.tsx







function Index() {
    var ref = (0,react.useState)('loading'), state = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        var cookies = (0,dist.parseCookies)(null);
        var indexApp = cookies.indexApp;
        var loadApp = indexApp || (0,user_agent/* isElectron */.d)();
        setState(loadApp ? 'app' : 'home');
    }, []);
    switch(state){
        case 'home':
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(home["default"], {}));
        case 'app':
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(dynamic_app/* DynamicApp */.J, {}));
        default:
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {}));
    }
};


/***/ }),

/***/ 1230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EM": function() { return /* binding */ metaKeyLabel; },
/* harmony export */   "Zx": function() { return /* binding */ isAppleOs; },
/* harmony export */   "Q5": function() { return /* binding */ isMacOs; },
/* harmony export */   "d": function() { return /* binding */ isElectron; }
/* harmony export */ });
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88306);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_memoize__WEBPACK_IMPORTED_MODULE_0__);

var isClient = "object" != 'undefined';
var metaKeyLabel = function() {
    var short = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        short: true
    }).short;
    return isAppleOs() ? short ? '&#8984;' : 'cmd' : 'ctrl';
};
var isAppleOs = lodash_memoize__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return isClient ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
});
var isMacOs = lodash_memoize__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return isClient ? /Mac/.test(navigator.platform) : false;
});
var isElectron = lodash_memoize__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    if (isClient) {
        return /Electron/i.test(navigator.userAgent);
    }
    return false;
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,7673,4653,2760,4272,3493,9774,2888,179], function() { return __webpack_exec__(45301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);